import type { ReactNode } from "react"

/*
 * Spotlight: the public check-in form. Distraction-free is not barren — the
 * form is a sheet of paper on the desk, set in the 15–16px world a school
 * contact reads once, with room for the wordmark and the seam at the end.
 */
export const SpotlightLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="bg-secondary_subtle min-h-screen w-full overflow-auto px-0 pt-0 sm:px-4 sm:pt-6 lg:px-8 lg:pt-[4vh]">
      <div className="sheet mx-auto w-full max-w-4xl rounded-none px-4 py-6 text-[15px] sm:rounded-xl sm:px-8 sm:py-8 lg:px-10 lg:py-10">
        {children}
      </div>
      <div className="h-8 sm:h-12" />
    </div>
  )
}
